export enum WhitelabelConfigCategory {
  BRANDING = 'BRANDING',
  SEO = 'SEO',
  INSTITUTIONAL = 'INSTITUTIONAL',
  LEGAL = 'LEGAL',
  CONTACT = 'CONTACT',
  CAPITALIZER = 'CAPITALIZER',
  BENEFICIARY = 'BENEFICIARY',
  VALIDATION = 'VALIDATION',
  WALLET = 'WALLET',
  INTEGRATION = 'INTEGRATION',
  EMAIL = 'EMAIL',
  SOCIAL = 'SOCIAL',
  BANNER = 'BANNER',
  COLOR = 'COLOR',
  PARTNERSHIP = 'PARTNERSHIP',
}

export enum BrandingKey {
  BRANDING_FOOTER_TEXT = 'BRANDING_FOOTER_TEXT',
  BRANDING_NAME = 'BRANDING_NAME',
  BRANDING_LOGO = 'BRANDING_LOGO',
  BRANDING_PRIZES_FOOTER_TEXT = 'BRANDING_PRIZES_FOOTER_TEXT',
  BRANDING_LOGO_WHEEL = 'BRANDING_LOGO_WHEEL',
  BRANDING_LUCKY_WHEEL_BG = 'BRANDING_LUCKY_WHEEL_BG',
  BRANDING_LUCKY_WHEEL_BG_DESKTOP = 'BRANDING_LUCKY_WHEEL_BG_DESKTOP',
  BRANDING_LOGO_FOOTER = 'BRANDING_LOGO_FOOTER',
  BRANDING_LOGO_HEADER = 'BRANDING_LOGO_HEADER',
  BRANDING_LOGO_MENU = 'BRANDING_LOGO_MENU',
}

export enum SeoKey {
  SEO_DESCRIPTION = 'SEO_DESCRIPTION',
  SEO_BASE_URL = 'SEO_BASE_URL',
  SEO_OG_IMAGE = 'SEO_OG_IMAGE',
  SEO_FAVICON = 'SEO_FAVICON',
  SEO_APPLE_ICON = 'SEO_APPLE_ICON',
}

export enum InstitutionalKey {
  INSTITUTIONAL_ABOUT_US = 'INSTITUTIONAL_ABOUT_US',
  INSTITUTIONAL_OUR_MISSION = 'INSTITUTIONAL_OUR_MISSION',
  INSTITUTIONAL_LABEL_ABOUT_US = 'INSTITUTIONAL_LABEL_ABOUT_US',
}

export enum LegalKey {
  LEGAL_PRIVACY_POLICY = 'LEGAL_PRIVACY_POLICY',
  LEGAL_USE_TERMS = 'LEGAL_USE_TERMS',
  LEGAL_GENERAL_CONDITIONS = 'LEGAL_GENERAL_CONDITIONS',
  LEGAL_RESPONSIBLE_GAMING = 'LEGAL_RESPONSIBLE_GAMING',
  LEGAL_CHECKOUT_CHECKBOXES = 'LEGAL_CHECKOUT_CHECKBOXES',
}

export enum CapitalizerKey {
  CAPITALIZER_LINK = 'CAPITALIZER_LINK',
  CAPITALIZER_NAME = 'CAPITALIZER_NAME',
  CAPITALIZER_LOGO = 'CAPITALIZER_LOGO',
  CAPITALIZER_LOGO_FOOTER = 'CAPITALIZER_LOGO_FOOTER',
  CAPITALIZER_DISPLAY_NAME = 'CAPITALIZER_DISPLAY_NAME',
  CAPITALIZER_SAQ_CONTACT = 'CAPITALIZER_SAQ_CONTACT',
  CAPITALIZER_MAIL = 'CAPITALIZER_MAIL',
  CAPITALIZER_OMBUDSMAN_CONTACT = 'CAPITALIZER_OMBUDSMAN_CONTACT',
  CAPITALIZER_COMMERCIAL_MAIL = 'CAPITALIZER_COMMERCIAL_MAIL',
  CAPITALIZER_LABEL_CAPITALIZER = 'CAPITALIZER_LABEL_CAPITALIZER',
}

export enum BeneficiaryKey {
  BENEFICIARY_NAME = 'BENEFICIARY_NAME',
  BENEFICIARY_LINK = 'BENEFICIARY_LINK',
  BENEFICIARY_LOGO = 'BENEFICIARY_LOGO',
  BENEFICIARY_ABOUT_US = 'BENEFICIARY_ABOUT_US',
  BENEFICIARY_LABEL = 'BENEFICIARY_LABEL',
}

export enum ValidationKey {
  VALIDATION_SKIP_ADDRESS_STEP = 'VALIDATION_SKIP_ADDRESS_STEP',
  VALIDATION_OTP_REQUIRED_DOWNLOAD_RECEIPT = 'VALIDATION_OTP_REQUIRED_DOWNLOAD_RECEIPT',
  VALIDATION_OTP_REQUIRED_PROFILE_UPDATE = 'VALIDATION_OTP_REQUIRED_PROFILE_UPDATE',
  VALIDATION_OTP_REQUIRED_PHONE_RECOVERY = 'VALIDATION_OTP_REQUIRED_PHONE_RECOVERY',
}

export enum WalletKey {
  WALLET_ENABLE_PAYMENT_WITH_BALANCE = 'WALLET_ENABLE_PAYMENT_WITH_BALANCE',
  WALLET_ENABLE_BALANCE = 'WALLET_ENABLE_BALANCE',
  WALLET_ENABLE_PIX_KEY = 'WALLET_ENABLE_PIX_KEY',
  WALLET_SKIP_IDENTITY_VERIFICATION_ON_WITHDRAWAL = 'WALLET_SKIP_IDENTITY_VERIFICATION_ON_WITHDRAWAL',
  WALLET_MIN_WITHDRAW_VALUE = 'WALLET_MIN_WITHDRAW_VALUE',
  WALLET_MAX_WITHDRAW_VALUE = 'WALLET_MAX_WITHDRAW_VALUE',
  WALLET_ALLOW_PARTIAL_WITHDRAWAL = 'WALLET_ALLOW_PARTIAL_WITHDRAWAL',
}

export enum SocialKey {
  SOCIAL_LATEST_WINNERS_VIDEOS = 'SOCIAL_LATEST_WINNERS_VIDEOS',
  SOCIAL_INSTAGRAM = 'SOCIAL_INSTAGRAM',
}

export enum ColorKey {
  // background (objeto)
  COLOR_BACKGROUND = 'COLOR_BACKGROUND',
  COLOR_BACKGROUND_GRADIENT = 'COLOR_BACKGROUND_GRADIENT',
  COLOR_BACKGROUND_VARIANT = 'COLOR_BACKGROUND_VARIANT',
  COLOR_BACKGROUND_GREY = 'COLOR_BACKGROUND_GREY',
  COLOR_BACKGROUND_DARK = 'COLOR_BACKGROUND_DARK',
  COLOR_BACKGROUND_HEADER = 'COLOR_BACKGROUND_HEADER',
  // tokens planos
  COLOR_FOREGROUND = 'COLOR_FOREGROUND',
  COLOR_SECTION = 'COLOR_SECTION',
  COLOR_FOOTER = 'COLOR_FOOTER',
  COLOR_FOOTER_TEXT = 'COLOR_FOOTER_TEXT',
  COLOR_BADGE = 'COLOR_BADGE',
  COLOR_HEADER_ICONS = 'COLOR_HEADER_ICONS',
  COLOR_CARD_BACKGROUND = 'COLOR_CARD_BACKGROUND',
  COLOR_HIGHLIGHT = 'COLOR_HIGHLIGHT',
  COLOR_BG_GRADIENT_BASE = 'COLOR_BG_GRADIENT_BASE',
  COLOR_BG_GRADIENT_VARIANT = 'COLOR_BG_GRADIENT_VARIANT',
  COLOR_CURRENCY = 'COLOR_CURRENCY',
  COLOR_QUANTITY_SELECTOR_BORDER = 'COLOR_QUANTITY_SELECTOR_BORDER',
  // primary
  COLOR_PRIMARY = 'COLOR_PRIMARY',
  COLOR_PRIMARY_HOVER = 'COLOR_PRIMARY_HOVER',
  COLOR_PRIMARY_TEXT = 'COLOR_PRIMARY_TEXT',
  COLOR_PRIMARY_FOREGROUND = 'COLOR_PRIMARY_FOREGROUND',
  // secondary
  COLOR_SECONDARY = 'COLOR_SECONDARY',
  COLOR_SECONDARY_HOVER = 'COLOR_SECONDARY_HOVER',
  COLOR_SECONDARY_TEXT = 'COLOR_SECONDARY_TEXT',
  COLOR_SECONDARY_FOREGROUND = 'COLOR_SECONDARY_FOREGROUND',
  COLOR_SECONDARY_VARIANT = 'COLOR_SECONDARY_VARIANT',
  // tertiary
  COLOR_TERTIARY = 'COLOR_TERTIARY',
  COLOR_TERTIARY_HOVER = 'COLOR_TERTIARY_HOVER',
  COLOR_TERTIARY_TEXT = 'COLOR_TERTIARY_TEXT',
  COLOR_TERTIARY_FOREGROUND = 'COLOR_TERTIARY_FOREGROUND',
  COLOR_TERTIARY_VARIANT = 'COLOR_TERTIARY_VARIANT',
  // status
  COLOR_SUCCESS = 'COLOR_SUCCESS',
  COLOR_ERROR = 'COLOR_ERROR',
  // accent
  COLOR_ACCENT = 'COLOR_ACCENT',
  COLOR_ACCENT_FOREGROUND = 'COLOR_ACCENT_FOREGROUND',
}

export enum PartnershipKey {
  PARTNERSHIP_LABEL = 'PARTNERSHIP_LABEL',
  PARTNERSHIP_ITEMS = 'PARTNERSHIP_ITEMS',
}

export enum IntegrationKey {
  INTEGRATION_COOKIE_SCRIPT = 'INTEGRATION_COOKIE_SCRIPT',
}

export type AnyWhitelabelConfigKey =
  | BrandingKey
  | SeoKey
  | InstitutionalKey
  | LegalKey
  | CapitalizerKey
  | BeneficiaryKey
  | ValidationKey
  | WalletKey
  | SocialKey
  | ColorKey
  | PartnershipKey
  | IntegrationKey;

export type CategoryOfKey<K extends AnyWhitelabelConfigKey> = K extends BrandingKey
  ? WhitelabelConfigCategory.BRANDING
  : K extends SeoKey
    ? WhitelabelConfigCategory.SEO
    : K extends InstitutionalKey
      ? WhitelabelConfigCategory.INSTITUTIONAL
      : K extends LegalKey
        ? WhitelabelConfigCategory.LEGAL
        : K extends CapitalizerKey
          ? WhitelabelConfigCategory.CAPITALIZER
          : K extends BeneficiaryKey
            ? WhitelabelConfigCategory.BENEFICIARY
            : K extends ValidationKey
              ? WhitelabelConfigCategory.VALIDATION
              : K extends WalletKey
                ? WhitelabelConfigCategory.WALLET
                : K extends SocialKey
                  ? WhitelabelConfigCategory.SOCIAL
                  : K extends ColorKey
                    ? WhitelabelConfigCategory.COLOR
                    : K extends PartnershipKey
                      ? WhitelabelConfigCategory.PARTNERSHIP
                      : K extends IntegrationKey
                        ? WhitelabelConfigCategory.INTEGRATION
                        : never;

function buildKeyToCategory(): Record<string, WhitelabelConfigCategory> {
  const groups: [Record<string, string>, WhitelabelConfigCategory][] = [
    [BrandingKey, WhitelabelConfigCategory.BRANDING],
    [SeoKey, WhitelabelConfigCategory.SEO],
    [InstitutionalKey, WhitelabelConfigCategory.INSTITUTIONAL],
    [LegalKey, WhitelabelConfigCategory.LEGAL],
    [CapitalizerKey, WhitelabelConfigCategory.CAPITALIZER],
    [BeneficiaryKey, WhitelabelConfigCategory.BENEFICIARY],
    [ValidationKey, WhitelabelConfigCategory.VALIDATION],
    [WalletKey, WhitelabelConfigCategory.WALLET],
    [SocialKey, WhitelabelConfigCategory.SOCIAL],
    [ColorKey, WhitelabelConfigCategory.COLOR],
    [PartnershipKey, WhitelabelConfigCategory.PARTNERSHIP],
    [IntegrationKey, WhitelabelConfigCategory.INTEGRATION],
  ];
  const map: Record<string, WhitelabelConfigCategory> = {};
  for (const [enumObj, category] of groups) {
    for (const value of Object.values(enumObj)) {
      if (process.env.NODE_ENV !== 'production' && value in map) {
        throw new Error(`Whitelabel key collision: "${value}" exists in multiple enums`);
      }
      map[value] = category;
    }
  }
  return map;
}

export const WHITELABEL_KEY_TO_CATEGORY = buildKeyToCategory();

export const WHITELABEL_KEY_TO_BRAND_PATH: Partial<
  Record<AnyWhitelabelConfigKey, string>
> = {
  // BRANDING
  [BrandingKey.BRANDING_FOOTER_TEXT]: 'footerText',
  [BrandingKey.BRANDING_NAME]: 'displayName',
  [BrandingKey.BRANDING_LOGO]: 'assets.logo',
  [BrandingKey.BRANDING_PRIZES_FOOTER_TEXT]: 'prizesFooterText',
  [BrandingKey.BRANDING_LOGO_WHEEL]: 'assets.logoWheel',
  [BrandingKey.BRANDING_LUCKY_WHEEL_BG]: 'assets.luckyWheelBackground',
  [BrandingKey.BRANDING_LUCKY_WHEEL_BG_DESKTOP]: 'assets.luckyWheelBackgroundDesktop',
  [BrandingKey.BRANDING_LOGO_FOOTER]: 'assets.logoFooter',
  [BrandingKey.BRANDING_LOGO_HEADER]: 'assets.logoHeader',
  [BrandingKey.BRANDING_LOGO_MENU]: 'assets.logoMenu',

  // SEO
  [SeoKey.SEO_DESCRIPTION]: 'meta.description',
  [SeoKey.SEO_BASE_URL]: 'meta.baseUrl',
  [SeoKey.SEO_OG_IMAGE]: 'meta.ogImage',
  [SeoKey.SEO_FAVICON]: 'meta.favicon',
  [SeoKey.SEO_APPLE_ICON]: 'meta.appleIcon',

  // INSTITUTIONAL
  [InstitutionalKey.INSTITUTIONAL_ABOUT_US]: 'institutional.aboutUs',
  [InstitutionalKey.INSTITUTIONAL_OUR_MISSION]: 'institutional.ourMission',
  [InstitutionalKey.INSTITUTIONAL_LABEL_ABOUT_US]: 'labels.aboutUs',

  // LEGAL
  [LegalKey.LEGAL_PRIVACY_POLICY]: 'institutional.privacyPolicy',
  [LegalKey.LEGAL_USE_TERMS]: 'institutional.useTerms',
  [LegalKey.LEGAL_GENERAL_CONDITIONS]: 'institutional.generalConditions',
  [LegalKey.LEGAL_RESPONSIBLE_GAMING]: 'institutional.responsibleGaming',
  [LegalKey.LEGAL_CHECKOUT_CHECKBOXES]: 'checkoutCheckboxes',

  // CAPITALIZER
  [CapitalizerKey.CAPITALIZER_LINK]: 'capitalizer.link',
  [CapitalizerKey.CAPITALIZER_NAME]: 'capitalizer.name',
  [CapitalizerKey.CAPITALIZER_LOGO]: 'capitalizer.logo',
  [CapitalizerKey.CAPITALIZER_LOGO_FOOTER]: 'capitalizer.logoFooter',
  [CapitalizerKey.CAPITALIZER_DISPLAY_NAME]: 'capitalizer.displayName',
  [CapitalizerKey.CAPITALIZER_SAQ_CONTACT]: 'capitalizer.saqContact',
  [CapitalizerKey.CAPITALIZER_MAIL]: 'capitalizer.mail',
  [CapitalizerKey.CAPITALIZER_OMBUDSMAN_CONTACT]: 'capitalizer.ombudsmanContact',
  [CapitalizerKey.CAPITALIZER_COMMERCIAL_MAIL]: 'capitalizer.commercialMail',
  [CapitalizerKey.CAPITALIZER_LABEL_CAPITALIZER]: 'labels.capitalizer',

  // BENEFICIARY
  [BeneficiaryKey.BENEFICIARY_LOGO]: 'capitalizer.beneficiaryLogo',
  [BeneficiaryKey.BENEFICIARY_LINK]: 'capitalizer.beneficiaryLink',
  [BeneficiaryKey.BENEFICIARY_NAME]: 'capitalizer.beneficiaryName',
  [BeneficiaryKey.BENEFICIARY_ABOUT_US]: 'capitalizer.beneficiaryAboutUs',
  [BeneficiaryKey.BENEFICIARY_LABEL]: 'labels.beneficiary',

  // VALIDATION
  [ValidationKey.VALIDATION_SKIP_ADDRESS_STEP]: 'skipAddressStep',
  [ValidationKey.VALIDATION_OTP_REQUIRED_PROFILE_UPDATE]:
    'validation.otpRequiredProfileUpdate',
  [ValidationKey.VALIDATION_OTP_REQUIRED_PHONE_RECOVERY]:
    'validation.otpRequiredPhoneRecovery',

  // WALLET
  [WalletKey.WALLET_ENABLE_PAYMENT_WITH_BALANCE]: 'validation.enablePaymentWithBalance',
  [WalletKey.WALLET_ENABLE_BALANCE]: 'validation.enableBalance',
  [WalletKey.WALLET_ENABLE_PIX_KEY]: 'validation.enablePixKey',
  [WalletKey.WALLET_SKIP_IDENTITY_VERIFICATION_ON_WITHDRAWAL]:
    'validation.skipIdentityVerificationOnWithdrawal',
  [WalletKey.WALLET_MIN_WITHDRAW_VALUE]: 'validation.minWithdrawValue',
  [WalletKey.WALLET_MAX_WITHDRAW_VALUE]: 'validation.maxWithdrawValue',

  // SOCIAL
  [SocialKey.SOCIAL_LATEST_WINNERS_VIDEOS]: 'latestWinnersVideos',

  // COLOR — background
  [ColorKey.COLOR_BACKGROUND]: 'colors.background.DEFAULT',
  [ColorKey.COLOR_BACKGROUND_GRADIENT]: 'colors.background.gradient',
  [ColorKey.COLOR_BACKGROUND_VARIANT]: 'colors.background.variant',
  [ColorKey.COLOR_BACKGROUND_GREY]: 'colors.background.grey',
  [ColorKey.COLOR_BACKGROUND_DARK]: 'colors.background.dark',
  [ColorKey.COLOR_BACKGROUND_HEADER]: 'colors.background.header',
  // COLOR — flat tokens
  [ColorKey.COLOR_FOREGROUND]: 'colors.foreground',
  [ColorKey.COLOR_SECTION]: 'colors.section',
  [ColorKey.COLOR_FOOTER]: 'colors.footer',
  [ColorKey.COLOR_FOOTER_TEXT]: 'colors.footerText',
  [ColorKey.COLOR_BADGE]: 'colors.badge',
  [ColorKey.COLOR_HEADER_ICONS]: 'colors.headerIcons',
  [ColorKey.COLOR_CARD_BACKGROUND]: 'colors.cardBackground',
  [ColorKey.COLOR_HIGHLIGHT]: 'colors.highlight',
  [ColorKey.COLOR_BG_GRADIENT_BASE]: 'colors.backgroundGradientBase',
  [ColorKey.COLOR_BG_GRADIENT_VARIANT]: 'colors.backgroundGradientVariant',
  [ColorKey.COLOR_CURRENCY]: 'colors.currencyColor.DEFAULT',
  [ColorKey.COLOR_QUANTITY_SELECTOR_BORDER]: 'colors.quantitySelectorBorder',
  // COLOR — primary
  [ColorKey.COLOR_PRIMARY]: 'colors.primary.DEFAULT',
  [ColorKey.COLOR_PRIMARY_HOVER]: 'colors.primary.hover',
  [ColorKey.COLOR_PRIMARY_TEXT]: 'colors.primary.text',
  [ColorKey.COLOR_PRIMARY_FOREGROUND]: 'colors.primary.foreground',
  // COLOR — secondary
  [ColorKey.COLOR_SECONDARY]: 'colors.secondary.DEFAULT',
  [ColorKey.COLOR_SECONDARY_HOVER]: 'colors.secondary.hover',
  [ColorKey.COLOR_SECONDARY_TEXT]: 'colors.secondary.text',
  [ColorKey.COLOR_SECONDARY_FOREGROUND]: 'colors.secondary.foreground',
  [ColorKey.COLOR_SECONDARY_VARIANT]: 'colors.secondary.variant',
  // COLOR — tertiary
  [ColorKey.COLOR_TERTIARY]: 'colors.tertiary.DEFAULT',
  [ColorKey.COLOR_TERTIARY_HOVER]: 'colors.tertiary.hover',
  [ColorKey.COLOR_TERTIARY_TEXT]: 'colors.tertiary.text',
  [ColorKey.COLOR_TERTIARY_FOREGROUND]: 'colors.tertiary.foreground',
  [ColorKey.COLOR_TERTIARY_VARIANT]: 'colors.tertiary.variant',
  // COLOR — status
  [ColorKey.COLOR_SUCCESS]: 'colors.success',
  [ColorKey.COLOR_ERROR]: 'colors.error',
  // COLOR — accent
  [ColorKey.COLOR_ACCENT]: 'colors.accent.DEFAULT',
  [ColorKey.COLOR_ACCENT_FOREGROUND]: 'colors.accent.foreground',
};
